import { DependencyList, useEffect } from 'react';

import { isEqual } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getTransfers } from 'src/actions';
import { Transfer } from 'src/models';
import { CustomHookBaseOptions } from 'src/models/common.model';

import { useAccountSelector } from './useAccountSelector';

const EMPTY_TRANSFERS: Transfer[] = [];

interface UseTransfersReturnType {
  transferList: Transfer[];
  isTransferListLoading: boolean;
  hasTransferListError?: boolean;
  transferListError?: string;
}

interface UseTransfersOptions extends CustomHookBaseOptions {
  refetchOnChange?: boolean;
  queryParams?: {
    startDate?: string;
    endDate?: string;
    sortyBy?: 'ascending' | 'descending';
    states?: string;
  };
  dependency?: DependencyList;
}

export const useTransfers = ({
  skip,
  refetchOnChange,
  queryParams,
  dependency = [],
}: UseTransfersOptions): UseTransfersReturnType => {
  const dispatch = useDispatch();
  const transferList: Transfer[] | undefined = useSelector((state: any) => state.cashiering.transfers?.data);
  const isTransferListLoading = useSelector((state: any) => Boolean(state.cashiering.transfers?.isLoading));
  const hasTransferListFailed: boolean = useSelector((state: any) => state.cashiering.transfers?.__failed);
  const transferListError: string = useSelector((state: any) => state.cashiering.transfers?.__message);
  const payload = useSelector((state: any) => state.cashiering.transfers?.payload);

  const { account } = useAccountSelector();

  const fetchList = () => {
    if (!account?.accountId) {
      return;
    }

    dispatch(getTransfers(account.accountId, queryParams));
  };

  useEffect(() => {
    if (skip) {
      return;
    }

    if (!transferList && !isTransferListLoading && !hasTransferListFailed) {
      fetchList();

      return;
    }

    if (refetchOnChange || !isEqual(payload, { accountId: account?.accountId, queryParams })) {
      fetchList();
    }
  }, dependency);

  return {
    transferList: Array.isArray(transferList) ? transferList : EMPTY_TRANSFERS,
    isTransferListLoading,
    hasTransferListError: hasTransferListFailed,
    transferListError,
  };
};
